/**
 * The build's release string (the git sha the Sentry release is named after),
 * read from index.html at runtime so it is never inlined into a hashed chunk.
 * One value serves the "Version" dialog, Sentry.init({ release }) and the
 * comparison with the backend's X-Bilderit-Release header.
 */
const readMeta = (name: string): string | undefined => {
  if (typeof document === 'undefined') return undefined;
  const content = document
    .querySelector(`meta[name="${name}"]`)
    ?.getAttribute('content')
    ?.trim();
  // Vite leaves `%VITE_X%` untouched when the variable is undefined (local dev
  // without SENTRY_RELEASE set) — treat that as unknown.
  if (!content || content.startsWith('%')) return undefined;
  return content;
};

export const getAppRelease = (): string | undefined =>
  readMeta('bilderit-release');

/** Short form for UI: first 7 characters, or 'dev' when unknown. */
export const getAppReleaseShort = (): string =>
  getAppRelease()?.slice(0, 7) ?? 'dev';
